import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginProps } from "./Login";
import styled from "styled-components";

const ShareSetting = ({ loginAccount, setStep, saveAccountDataAndLogin }: LoginProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const checkType = location.state?.checkType;

  const loginSingleUser = () => {
    console.log('loginAccount', loginAccount);
    //if (setStep) {
    //  setStep(6);
    //}
    if (loginAccount && loginAccount.length > 0) {
      let oLoginData = loginAccount[0];
      if (oLoginData && oLoginData.use_password === 1) {
        navigate("/payment/password", { state: { passwordType: "login", loginAccount: JSON.stringify(oLoginData) } })
      } else {
        let oAccountData: any = oLoginData;
        if (saveAccountDataAndLogin) {
          saveAccountDataAndLogin(oAccountData);
        }
      }
    }
  };

  const goNextStep = () => {
    if (setStep) {
      setStep(2);
    }
  };

  return (
    <Style>
      <div className="wrapper">
        <h1 className="logo">차량을 공유하시겠습니까?</h1>
        <div className="listWrap">
          <div className="buttonBorder">
            <button onClick={loginSingleUser}>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_single.svg`}
                alt="single"
              />
              <h1>단독사용</h1>
            </button>
          </div>
          <div className="buttonBorder">
            <button onClick={goNextStep}>
              <img
                src={`${process.env.PUBLIC_URL}/svg/ic_union.svg`}
                alt="union"
              />
              <h1>공유자 있음</h1>
            </button>
          </div>
        </div>
      </div>
    </Style>
  );
};
export default ShareSetting;

const Style = styled.div`
  .wrapper {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }
  h1.title {
    font-size: 44px;
    line-height: 104px;
    font-weight: 500;
    margin-bottom: 55px;
  }
  h2 {
    margin-top: 18px;
    font-size: 24px;
    font-weight: 500;
    line-height: 33px;
  }
  .logo {
    line-height: 100px;
    max-height: 100px;
    margin-bottom: 55px;
  }

  .listWrap {
    max-width: 100%;
    display: flex;
    padding: 0 10%;
    gap: 60px;
    overflow-x: auto;
  }
  .buttonBorder {
    min-width: 400px;
    max-width: 400px;
    min-height: 360px;
    max-height: 360px;
    padding: 3px;
    border-radius: 20px;
    background: linear-gradient(118.64deg, #dedede 2.57%, #262626 96.35%);
    button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 100%;
      height: 100%;
      border-radius: 20px;
      background: linear-gradient(360deg, #111111 3.5%, #494949 100%);
      h1 {
        line-height: 80px;
        font-weight: 600;
      }
      h1.img {
        font-size: 56px;
        line-height: 120px;
      }
      img {
        width: 80px;
        height: 80px;
      }
    }
  }
  .buttonBorder.active {
    background: linear-gradient(281.11deg, #132756 1.98%, #ccddff 97.75%);
    button {
      background: linear-gradient(180deg, #648fe7 3.06%, #0d2a6c 97.5%);
    }
  }
`;
